import React from "react";
import {
  Dialog,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import check from "../../../../../../assets/images/check.svg";
import { CheckCircleOutline } from "@mui/icons-material";
import ButtonComp from "../../../../../../components/Button";

type VerifiedDraftPopupProps = {
  open: boolean;
  onClose: () => void;
  label: string;
  text?: string;
  policyNumber?: string;
  handleContinue: () => void;
};

const VerifiedDraftPopup: React.FC<VerifiedDraftPopupProps> = ({
  open,
  onClose,
  label,
  text,
  handleContinue,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "visible",
          px: 4,
          pt: 10,
          pb: 3,
          position: "relative",
          boxShadow: 5,
          borderBottom: "6px solid #20BF55",
          height: 580,
        },
      }}
    >
      {/* Green Circle Icon */}
      <Box
        sx={{
          position: "absolute",
          top: -60,
          left: "50%",
          transform: "translateX(-50%)",
          width: 125,
          height: 125,
          borderRadius: "50%",
          backgroundColor: "background.default",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "inset 0 0 12px rgba(0, 0, 0, 0.2)",
        }}
      >
        <img
          src={check}
          alt="Logo"
          style={{ height: 70, width: 70, objectFit: "contain" }}
        />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
        mb={2}
      >
        <Typography
          fontSize={{ xs: 26, sm: 38 }}
          fontWeight={600}
          color="#20BF55"
        >
          {label}
        </Typography>
        <Typography
          fontSize={{ xs: 12, sm: 16 }}
          fontWeight={600}
          color="text.secondary"
        >
          {text}
        </Typography>
      </Box>

      {/* </DialogContent> */}
      <Box textAlign="left" mb={2}>
        <Box display="flex" alignItems="flex-start" mb={1}>
          <CheckCircleOutline sx={{ color: "#20BF55", mr: 1 }} />
          <Box>
            <Typography fontWeight={600} fontSize={{ xs: 13, sm: 16 }}>
              5 Years of Continuous Coverage
            </Typography>
            <Typography variant="body2" fontSize={{ xs: 13, sm: 16 }}>
              Your policy has been active for the past 5 years without any
              missed or defaulted payments.
            </Typography>
          </Box>
        </Box>

        <Box display="flex" alignItems="flex-start" mb={1}>
          <CheckCircleOutline sx={{ color: "#20BF55", mr: 1 }} />
          <Box>
            <Typography fontWeight={600} fontSize={{ xs: 13, sm: 16 }}>
              No Previous Claims
            </Typography>
            <Typography variant="body2" fontSize={{ xs: 13, sm: 16 }}>
              We found no history of claims associated with your policy.
            </Typography>
          </Box>
        </Box>

        <Box display="flex" alignItems="flex-start" mb={1}>
          <CheckCircleOutline sx={{ color: "#20BF55", mr: 1 }} />
          <Box>
            <Typography fontWeight={600} fontSize={{ xs: 13, sm: 16 }}>
              Policy Has Never Lapsed
            </Typography>
            <Typography variant="body2" fontSize={{ xs: 13, sm: 16 }}>
              Your policy has remained active and uninterrupted since its
              inception.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Typography fontWeight={600} fontSize={{ xs: 12, sm: 16 }}>
        You can apply now for 10% claim processing through the ICE-Claim system!
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          py: { xs: 1, sm: 4 },
          flexDirection: { xs: "column", sm: "row" },
          gap: { xs: 1 },
        }}
      >
        <ButtonComp
          variant="outlined"
          height={40}
          fontSize="16px"
          width={{ xs: "100%", sm: 190 }}
          onClick={onClose}
        >
          CANCEL
        </ButtonComp>

        <ButtonComp
          variant="contained"
          height={40}
          fontSize="16px"
          width={{ xs: "100%", sm: 190 }}
          onClick={() => {
            handleContinue();
            onClose();
          }}
        >
          CONTINUE
        </ButtonComp>
      </Box>
    </Dialog>
  );
};

export default VerifiedDraftPopup;
